import useSWR from 'swr';
import { useMemo } from 'react';
// utils
import axios, { fetcher, endpoints } from 'src/utils/axios';

// types
import { IResponse } from 'src/types/DTO/IResponse';
import { IActivtyLog } from 'src/types/DTO/activityLog/IActivityLog';
import { IParamBasic } from 'src/types/ParamBasic';

// ----------------------------------------------------------------------

// XỬ LÝ API NHẤT KÝ HOẠT ĐỘNG

// ----------------------------------------------------------------------

export function useGetActivityLogs(params?: IParamBasic) {
  const URL = params
    ? [
        endpoints.common.activity_log,
        {
          params: {
            ...params,
          },
        },
      ]
    : endpoints.common.activity_log;

  const { data, isLoading, error, isValidating, mutate } = useSWR<IResponse<IActivtyLog[]>>(
    URL,
    fetcher
  );

  // console.log(data, isLoading, error, isValidating);

  const activityLogs = data?.data.list;
  const memoizedValue = useMemo(
    () => ({
      data: {
        status: data?.status,
        message: data?.message,
        data: {
          list: activityLogs || [],
          pagination: data?.data.pagination,
        },
      },
      isLoading,
      error,
      isValidating,
      mutate,
    }),
    [data, isLoading, error, isValidating, mutate]
  );

  return memoizedValue;
}

// ----------------------------------------------------------------------

export async function getActivityLogs(params?: IParamBasic & { from?: string }) {
  const URL = endpoints.common.activity_log;
  const { data } = await axios.get(URL, { params });

  const activityLogs = data?.data.list;

  return {
    status: data?.status,
    message: data?.message,
    data: {
      list: activityLogs || [],
      pagination: data?.data.pagination,
    },
  };
}
